import { useState, useEffect } from "react";
import { API_ROOT } from "../utils/apiConfig";

/**
 * Custom hook to fetch home page content from the backend
 * @returns {Object} - { data, isLoading, error }
 */
export const useHomeContent = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeContent = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const url = `${API_ROOT}/api/home/content`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(
            `Failed to fetch home content: ${response.statusText}`,
          );
        }

        const result = await response.json();
        setData(result.data || {});
      } catch (err) {
        console.error("Error fetching home content:", err);
        setError(err.message);
        // Return empty structure to prevent UI breaks
        setData({});
      } finally {
        setIsLoading(false);
      }
    };

    fetchHomeContent();
  }, []);

  return {
    data,
    isLoading,
    error,
  };
};
